import ExampleHook from "./example-hook";
import ResizeTextareaHook from "./resize-textarea-hook";
import MessageInputHook from "./message-input-hook";
import ClearFlashHook from "./clear-flash-hook";
import ScrollTopHook from "./scroll-top-hook";
import ColorSchemeHook from "./color-scheme-hook";
import ClipboardHook from "./clipboard-hook";
import TippyHook from "./tippy-hook";
import LocalTimeHook from "./local-time-hook";
import ComboBoxHook from "./combo-box-hook";
import FloatingHook from "./floating-hook";
import AutosaveIndicator from "./autosave-indicator-hook";
import ChartJsHook from "./chart-js-hook";
import FocusBySelectorHook from "./focus-by-selector-hook";
import MicrophoneHook from "./microphone-hook";
import ScrollPosition from "./scroll-position";
import ChatScroll from './chat_scroll';
import DownloadHook from "./download-hook";
import LeadRealtimeHook from "./lead-realtime-hook";
import SmartDropdownFormHook from "./smart-dropdown-form-hook";
import AddUserFormHook from "./add-user-form-hook";
import PortalHook from "./portal-hook";
import KeyboardNavigationHook from "./keyboard-navigation-hook";
import ScrollManagerHook from "./scroll-manager-hook";
import FocusTrapHook from "./focus-trap-hook";
import PushNotificationsHook from "./push_notifications_hook";
import SwipeGestureHook from "./swipe-gesture-hook";
import SwipeActionsHook from "./swipe-actions-hook";
import PullToRefreshHook from "./pull-to-refresh-hook";
import NarrativeInputHook from "./narrative-input-hook";
import VoiceDictation from "./voice_dictation";
import WebAuthnHook from "./webauthn-hook";
import LeadDraftHook from "./lead-draft-hook";
import UploadNetworkHook from "./upload-network-hook";
import CommandPaletteHook from "./command-palette-hook";
import OfflineQueueHook from "./offline-queue-hook";
import OfflineQueueFormHook from "./offline-queue-form-hook";
import LeadDraftLocalHook from "./lead-draft-local-hook";
import ResumeHubHook from "./resume-hub-hook";
import LoadingIndicatorHook from "./loading-indicator-hook";
import FocusModeHook from "./focus-mode-hook";
import FlashBatchHook from "./flash-batch-hook";
import UploadResilienceHook from "./upload-resilience-hook";
import LayoutChromeHook from "./layout-chrome-hook";
import CaseSessionHook from "./case-session-hook";
import PdfInlineFrameHook from "./pdf-inline-frame-hook";

export default {
  ExampleHook,
  ResizeTextareaHook,
  MessageInputHook,
  ClearFlashHook,
  ScrollTopHook,
  ColorSchemeHook,
  ClipboardHook,
  TippyHook,
  LocalTimeHook,
  ComboBoxHook,
  FloatingHook,
  AutosaveIndicator,
  ChartJsHook,
  FocusBySelectorHook,
  MicrophoneHook,
  ScrollPosition,
  ChatScroll,
  DownloadHook,
  LeadRealtimeHook,
  SmartDropdownFormHook,
  AddUserFormHook,
  PortalHook,
  KeyboardNavigationHook,
  ScrollManagerHook,
  FocusTrapHook,
  PushNotificationsHook,
  SwipeGestureHook,
  SwipeActionsHook,
  PullToRefreshHook,
  NarrativeInputHook,
  VoiceDictation,
  WebAuthnHook,
  LeadDraftHook,
  UploadNetworkHook,
  CommandPaletteHook,
  OfflineQueueHook,
  OfflineQueueFormHook,
  LeadDraftLocalHook,
  ResumeHubHook,
  LoadingIndicatorHook,
  FocusModeHook,
  FlashBatchHook,
  UploadResilienceHook,
  LayoutChromeHook,
  CaseSessionHook,
  PdfInlineFrameHook
};
